import { PureComponent } from 'react';
import { Model } from 'backbone';
import { PropTypes as T } from 'prop-types';
import { get, set } from 'lodash/object';

/* Ignore these rules because we're baseclassing */
/* eslint react/no-unused-state: 0, react/no-unused-prop-types: 0 */

export default class BaseInput extends PureComponent {
  static propTypes = {
    model: T.instanceOf(Model),
    property: T.string.isRequired,
    bsSize: T.string,
    className: T.string,
    id: T.string,
    defaultValue: T.oneOf([T.string, T.number]),
  }

  static getValueFromModel(model, property) {
    const [prop, ...dots] = property.split('.');

    if (dots.length) {
      return get(model.get(prop), dots);
    }

    return model.get(prop);
  }

  static getModelChange(model, property, value) {
    const [prop, ...dots] = property.split('.');

    if (dots.length) {
      return {
        [prop]: {
          ...model.get(prop),
          ...set(model.get(prop), dots, value),
        },
      };
    }

    return { [property]: value };
  }

  constructor(props) {
    super(props);

    const {
      model,
      property,
      defaultValue,
    } = props;

    this.state = {
      value: this.constructor.getValueFromModel(model, property) || defaultValue,
    };

    // handle server responses which may update the value
    model.on('sync', () => this.onModelUpdate());

    // handle external updates
    model.on('change', () => this.onModelUpdate());
  }

  onModelUpdate() {
    this.setState({
      value: this.constructor.getValueFromModel(this.props.model, this.props.property),
    });
  }

  update(value) {
    this.props.model.set({
      ...this.constructor.getModelChange(this.props.model, this.props.property, value),
    }, { silent: true });

    this.setState({ value });
  }
}




// WEBPACK FOOTER //
// ./app/components/forms/input/base.jsx